export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9374.92d0e5aa.jpg";